import styled from 'styled-components';
import { RadioButton, Typography } from '@web-chat-core/ui-kit';

export const SettingsContent = styled.div`
    padding: 0 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const Devider = styled.div`
    width: 100%;
    height: 1px;
    margin: 24px 0;
    background-color: ${(props) => props.theme.root.colors.basicColors['6%']};
`;

export const JoinPolicyRadioContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const JoinPolicyRadioWrapper = styled.div`
    margin-bottom: 2px;
`;

export const JoinPolicyRadio = styled(RadioButton)`
    label > span > div {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.1px;
    }
`;

export const SectionTitle = styled(Typography)`
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: ${(props) => props.theme.root.colors.basicColors['60%']};
`;

export const ToggleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

export const ToggleRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

export const ToggleInfo = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const ToggleLabel = styled(Typography)`
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 10px;
    font-weight: 500;
    letter-spacing: 0.1px;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
`;

export const ToggleDescription = styled.div`
    color: ${(props) => props.theme.root.colors.basicColors['50%']};
    font-size: 14px;
    line-height: 18px;
`;
